import type { BadgeVariant } from "@/components/ui/baseUi/badge"
import type { FinanceStatisticsEntity } from "@/modules/finances/entities/financeStatisticsEntity"

export type PaymentsToValidateModel = {
  paymentToValidate: {
    total: number
    count: number
    badgeVariant: BadgeVariant
  }
  paymentFailed: {
    total: number
    count: number
    badgeVariant: BadgeVariant
  }
  paymentDisputed: {
    total: number
    count: number
    badgeVariant: BadgeVariant
  }
}

export function createPaymentsToValidateSummaryModel(
  stats: FinanceStatisticsEntity | null,
  displayIntense: boolean,
): PaymentsToValidateModel {
  if (!stats) {
    return {
      paymentToValidate: {
        total: 0,
        count: 0,
        badgeVariant: "positiveSubtle",
      },
      paymentFailed: {
        total: 0,
        count: 0,
        badgeVariant: "positiveSubtle",
      },
      paymentDisputed: {
        total: 0,
        count: 0,
        badgeVariant: "positiveSubtle",
      },
    }
  }
  return {
    paymentToValidate: {
      total: stats.toValidate.pending.total,
      count: stats.toValidate.pending.count,
      badgeVariant:
        stats.toValidate.pending.count > 0 ? (displayIntense ? "noticeIntense" : "noticeSubtle") : "positiveSubtle",
    },
    paymentFailed: {
      total: stats.toValidate.failed.total,
      count: stats.toValidate.failed.count,
      badgeVariant:
        stats.toValidate.failed.count > 0 ? (displayIntense ? "negativeIntense" : "negativeSubtle") : "positiveSubtle",
    },
    paymentDisputed: {
      total: stats.toValidate.disputed.total,
      count: stats.toValidate.disputed.count,
      badgeVariant:
        stats.toValidate.disputed.count > 0 ? (displayIntense ? "noticeIntense" : "noticeSubtle") : "positiveSubtle",
    },
  }
}
